// 发票信息管理
import {contractApi} from "@/axios";
//获取发票信息
export function getTicketsPage(params,data){
    return contractApi({
        url:'/invoice-info/page',
        method:'post',
        data:data,
        params:params
    })
}
//删除发票信息
export function deleteTickets(params){
    return contractApi({
        url:'/invoice-info',
        method:'delete',
        params:params
    })
}
//添加发票信息
export function addTickets(data){
    return contractApi({
        url:'/invoice-info',
        method:'post',
        data:data,
        headers: {
            'Content-Type': 'multipart/form-data' // 指定内容类型为 form-data
        }
    })
}
//修改发票信息
export function editTickets(data){
    return contractApi({
        url:'/invoice-info',
        method:'put',
        data:data,
        headers: {
            'Content-Type': 'multipart/form-data' // 指定内容类型为 form-data
        }
    })
}
//发票审核
// export function auditTickets(data){
//     return contractApi({
//         url:'/invoice-info/audit',
//         method:'put',
//         data:data
//     })
// }
//下载附件
export function attachmentTickets(id) {
    return contractApi({
        url: '/invoice-info/attachment/' + id,
        method: 'get',
        responseType: 'blob', // 设置响应类型为 blob
    });
}
//退票
export function refundTickets(data){
    return contractApi({
        url:'/invoice-info/refund-request',
        method:'put',
        data:data
    })
}
//退票审核
export function refundAudit(data){
    return contractApi({
        url:'/invoice-info/refund-audit',
        method:'put',
        data:data
    })
}
//退票成功
export function refundSuccess(params){
    return contractApi({
        url:'/invoice-info/refund-success',
        method:'put',
        params:params
    })
}
//修改发票信息
export function getPdfNum(params,data){
    return contractApi({
        url:'/invoice-info/get-invoice-pdf-num',
        method:'post',
        params:params,
        data:data,
        headers: {
            'Content-Type': 'multipart/form-data' // 指定内容类型为 form-data
        }
    })
}
//取消开票
export function cancelInvoice(params){
    return contractApi({
        url:'/invoice-info/cancel-invoicing',
        method:'put',
        params:params
    })
}
//获取未到款、部分到款发票
export function getInvoice(){
    return contractApi({
        url:'/invoice-info/get-invoice',
        method:'get'
    })
}
//导出发票信息
export function exportInvoice(data) {
    return contractApi({
        url: '/invoice-info/export',
        method: 'post',
        data:data,
        responseType: 'blob', // 设置响应类型为 blob
    });
}
//下载信息提交
export function downloadBatch(key,data) {
    return contractApi({
        url: '/invoice-info/download-batch/' + key,
        method: 'post',
        data: data
    });
}
//批量下载发票
export function invoiceDownload(key) {
    return contractApi({
        url: '/invoice-info/attachment-batch/' + key,
        method: 'get'
    });
}
//销售申请取消开票
export function saleCancelInvoice(data){
    return contractApi({
        url:'/invoice-info/sale-cancel-invoicing',
        method:'put',
        data:data
    })
}